<template>
  <main class="renew3_top renew3_top_new">
    <!--メインバナー-->
    <div class="mv">
      <div class="renew3_wrapper mv_wrapper">
        <a href="" class="mv_link">
          <img
            src="/static/renew3_img/top20250124.png"
            alt="コンビニ印刷"
            class="mv_img"
          />
        </a>
      </div>
    </div>

    <TopFormatBlocks />

    <!--ヤギッシュのサービス-->
    <div class="service">
      <div class="renew3_wrapper service_wrapper">
        <h3 class="service_h3">ヤギッシュのサービス</h3>

        <div class="service_list">
          <div class="service_item">
            <p class="service_item_title">履歴書を作成して、</p>
            <div class="flex service_img_list">
              <img
                src="/static/renew2_img/service01.png"
                alt="PDFで出力&amp;メール送信"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service02.png"
                alt="コンビニ印刷"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service03.png"
                alt="バックアップ＆復元"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service04.png"
                alt="自動でブラウザ保存"
                class="service_img_item"
              />
            </div>
          </div>

          <div class="service_item">
            <p class="service_item_title">履歴書を作成中、</p>
            <div class="flex service_img_list">
              <img
                src="/static/renew2_img/service09.png"
                alt="AIに文章作成"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service08.png"
                alt="フォント切り替え"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service11.png"
                alt="専属エージェント"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service07.png"
                alt="推薦書付き履歴書"
                class="service_img_item"
              />
            </div>
          </div>

          <div class="service_item">
            <p class="service_item_title">履歴書を作成後、</p>
            <div class="flex service_img_list">
              <img
                src="/static/renew2_img/service10.png"
                alt="AIと面接練習"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service05.png"
                alt="履歴書送信サービス"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service12.png"
                alt="オファーサービス"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service06.png"
                alt="転職相談就職支援"
                class="service_img_item"
              />
            </div>
          </div>
        </div>

        <div class="flex formatbtn_list">
          <a
            href="/format/rirekisho_job_change"
            class="formatbtn_link formatbtn_link1"
            >履歴書をつくる</a
          >
          <a
            href="/format/shokumukeirekisho"
            class="formatbtn_link formatbtn_link2"
            >経歴書をつくる</a
          >
          <a href="/format/letter" class="formatbtn_link formatbtn_link3"
            >送付状をつくる</a
          >
        </div>
      </div>
    </div>

    <!--お問い合わせ-->
    <div class="contact">
      <div class="renew3_wrapper contact_wrapper">
        <div class="flex contact_list">
          <a
            href="https://cs.yagish.jp/contact.html?type=corp"
            target="_blank"
            class="pc contact_link"
          >
            <span>パートナーについての</span><br />相談をする</a
          >
          <a
            href="/contact"
            target="_blank"
            rel="noopener noreferrer"
            class="contact_link"
          >
            <span>履歴書作成についての</span><br />お問い合わせ</a
          >
          <a
            href="https://cs.yagish.jp/contact.html?type=corp"
            target="_blank"
            class="sp contact_link"
          >
            <span>パートナーについての</span><br />相談をする</a
          >
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import localforage from 'localforage'
import { emitter } from '@/plugins/emitter'
import TopFormatBlocks from '@/components/top/TopFormatBlocks.vue'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'

type RecentEdit = {
  FormatId: string
}

const isNotMidnight = ref(true)
const recentEdit = ref<RecentEdit>({
  FormatId: ''
})

function reload(): void {
  location.reload()
}

async function loadRecentEdit(): Promise<void> {
  try {
    const data = await localforage.getItem<RecentEdit>(RECENT_EDIT_SAVE_KEY)
    if (data) {
      recentEdit.value = data
    }
  } catch (err) {
    console.log(err)
  }
}

function updateRecentEdit(data: RecentEdit): void {
  if (data) {
    recentEdit.value = data
  }
}

onMounted(async () => {
  await loadRecentEdit()
  const hour = new Date().getHours()
  if (hour >= 0 && hour < 6) {
    isNotMidnight.value = false
  }
  emitter.on('change-recent-edit', updateRecentEdit)
  emitter.on('reload', reload)
})

onBeforeUnmount(() => {
  emitter.off('change-recent-edit', updateRecentEdit)
  emitter.off('reload', reload)
})
</script>

<style lang="scss" src="@/assets/scss/top/TopNew.scss"></style>
